<div class="container pt-3 pb-3 report-component">
  <app-report-view></app-report-view>
</div>